module.exports = "/assets/landing-rc/cuisines/45.jpg?gFDHvxV";